module.exports = __webpack_public_path__ + "img/61e207698cf4e99acf33b4183df738fe.png";